export const sidebarLayout = {
  default: ['{numbers}', '{abc}', '{kana}'],
};

export const actionLayout = {
  default: ['{bksp}', '{space}', '{enter}'],
  withCandidates: ['{bksp}', '{nextCandidate}', '{enter}'],
};
